import axios from 'axios';
import LsService from './localstorage';

export const API_URL = 'https://apimultistorepos.invtechnologies.in';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to add token to all requests
api.interceptors.request.use(
    (config) => {
        const user = authService.getCurrentUser();
        if (user?.token) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            authService.logout();
            window.location.href = '/login-creator';
        }
        return Promise.reject(error);
    }
);

const authService = {
    login: async (credentials) => {
        try {
            const response = await api.post('/login', credentials);
            const { data } = response;
            
            if (data.token && data.user) {
                const userData = {
                    token: data.token,
                };
                LsService.setItem("invCreator", userData);
                authService.setAuthToken(data.token);
                return {
                    success: true,
                    userName: data.user.username,
                    role: data.user.role
                };
            }
            
            return {
                success: false,
                message: 'Invalid response from server'
            };
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'An error occurred during login';
            throw new Error(errorMessage);
        }
    },

    logout: () => {
        LsService.setItem("invCreator", null);
        delete api.defaults.headers.common['Authorization'];
        window.location.href = '/login-creator';
    },

    getCurrentUser: () => {
        try {
            const userStr = localStorage.getItem('invCreator');
            return userStr ? JSON.parse(userStr) : null;
        } catch (error) {
            authService.logout();
            return null;
        }
    },

    setAuthToken: (token) => {
        if (token) {
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            delete api.defaults.headers.common['Authorization'];
        }
    },

    // Verify if the current token is still valid
    verifyToken: async () => {
        try {
            const response = await api.get('/verify-token');
            return response.data.valid;
        } catch (error) {
            authService.logout();
            return false;
        }
    },

    // Check if user is authenticated
    isAuthenticated: () => {
        const user = authService.getCurrentUser();
        return !!user?.token;
    },

    // Get user role
    getUserRole: () => {
        const userData = authService.getCurrentUser();
        return userData?.user?.role || null;
    }
};

export default authService; 